import {
	Coded, 
	CustomerDto, 
	Id,
	InvoiceDto
} from "../../../models/businesses";

const key = "fake-report-invoices";

const applicable = (resp) => {
	// api/forms/${formId}/reports/${reportId}/invoices
	const matches = (resp.config.method === "GET") && resp.config.url.match(/api\/forms\/[0-9]*\/reports\/[0-9]*\/invoices/);

	return matches;
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	const data: InvoiceDto[] = [
		{
			Id: 123 as Id<"Invoice">,
			Transactions: [
				{
					Item: "Invoice 1, Item 1",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 1, Item 2",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 1, Item 3",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				}
			],
			Due: {
				Credit: 100,
				Deductions: 30
			},
			Subtotal: 6,
			Fees: 3,
			Total: 9,
			Customer: { Name: "Test Customer" } as CustomerDto,
			State: {
				Code: "755ae2f0-d398-4c93-b035-3b5f6ca28783",
				IsVoid: false,
				IsPaid: false
			}
		},
		{
			Id: 123 as Id<"Invoice">,
			ReferenceNum: "Abc123",
			Transactions: [
				{
					Item: "Invoice 3, Item 1",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 3, Item 2",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 3, Item 3",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				}
			],
			Due: {
				Credit: 200,
				Deductions: 40
			},
			Subtotal: 6,
			Fees: 3,
			Total: 9,
			Customer: { Name: "Test Customer" } as CustomerDto,
			State: {
				Code: "755ae2f0-d398-4c93-b035-3b5f6ca28783",
				IsVoid: false,
				IsPaid: false
			}
		},
		{
			Id: 123 as Id<"Invoice">,
			Transactions: [
				{
					Item: "Invoice 2, Item 1",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 2, Item 2",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				},
				{
					Item: "Invoice 2, Item 3",
					Price: 1,
					Fees: [
						{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
						{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
					],
					Fee: 14,
					Subtotal: 2,
					Total: 3
				}
			],
			Due: {
				Credit: 300,
				Deductions: 10
			},
			Subtotal: 6,
			Fees: 3,
			Total: 9,
			Customer: { Name: "Test Customer" } as CustomerDto,
			State: {
				Code: "755ae2f0-d398-4c93-b035-3b5f6ca28783",
				IsVoid: false,
				IsPaid: false
			}
		}
	];

	resp.data.Data = data;

	// eslint-disable-next-line no-console
	console.info("Faking invoices response", resp);
	return resp;
};

export const fakeReportInvoices = [key, applicable, modify];